import React from "react";
import { Link } from "react-router-dom";
import '../../Style/ComonStyles.css'
import './Portfolio.css';
import Portfolio1 from '../../../src/images/portfolio1.jpg'
import Portfolio2 from '../../../src/images/portfolio2.jpg'
import Portfolio3 from '../../../src/images/portfolio3.jpg'
import Portfolio4 from '../../../src/images/portfolio4.jpg'
import Portfolio5 from '../../../src/images/portfolio5.jpg'
import Portfolio6 from '../../../src/images/portfolio6.jpg'

const Portfolio = () => {

    const portfolioInfo = [
        {
            id: 1,
            title: 'Portfolio',
            heading: 'Tailor Swift- Logo Designer',
            img: Portfolio1,
            des: ['html', 'css', 'bootstrap', 'javascript', 'react']
        },
        {
            id: 2,
            title: 'Doctors & Patient Services',
            heading: 'Doctors Portal',
            img: Portfolio2,
            des: ['html', 'css', 'tailwind css', 'javascript', 'react']
        },
        {
            id: 3,
            title: 'Animated website',
            heading: 'Danna Karan- Fashion Designer',
            img: Portfolio3,
            des: ['html', 'css', 'sass', 'javascript', 'react', 'framer motion']
        },
        {
            id: 4,
            title: 'Real Estate',
            heading: 'Nabhan Properties Ltd.',
            img: Portfolio4,
            des: ['html', 'css', 'tailwind css', 'react js']
        },
        {
            id: 5,
            title: 'Hotel Booking Website',
            heading: 'Nabhan Sky View',
            img: Portfolio5,
            des: ['html', 'css', 'tailwind css', 'react js',]
        },
        {
            id: 6,
            title: 'Business Consultant',
            heading: 'Next Generation Consult',
            img: Portfolio6,
            des: ['html', 'css', 'bootstrap']
        },
    ]
    return (
        <div className="portfolio-section py-5">
            <div className="container">
                <div className='text-center mb-5'>
                    <p><span className='text-uppercase text-light'>my</span> <span className='text-capitalize heading-three'>client</span></p>
                    <h2 className='heading-two'>Projects</h2>
                </div>
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {
                        portfolioInfo.map(portfolio => <div class="col ">
                            <div class="card h-100 text-light portfolio-card">
                                <div class="img-container">
                                    <img src={portfolio.img} class="card-img-top" alt="..." />
                                </div>

                                <div class="card-body">
                                    <h6 class="card-title">{portfolio.title}</h6>
                                    <h3 className="cart-title text-color py-3">{portfolio.heading}</h3>
                                    <h6 className="">Uses Language</h6> <hr/>
                                    {portfolio.des.map(list => (
                                        <li class="card-text">{list}</li>
                                    ))}
                                    
                                    <Link to='/contact' className='btn btn-portfolio my-3'><span>Live Preview</span></Link>
                                </div>
                            </div>
                        </div>)
                    }
                </div>
                <div className="text-center py-5">
                    <Link to='/' className="btn btn-portfolio mx-auto"><span>VIEW MORE</span> </Link>
                </div>
            </div>
        </div>
    );
};

export default Portfolio;